export enum StatusColor {
  warn = 'warn',
  accent = 'accent',
  primary = 'primary',
  orange = 'orange',
  grey3 = 'grey-3',
  grey4 = 'grey-4'
}
